import { useRef } from "react";
import { categories } from "@/mocks/categories";

export default function CategoryScroll() {
  const scrollRef = useRef<HTMLDivElement>(null);

  const scroll = (direction: "left" | "right") => {
    if (scrollRef.current) {
      const amount = 320;
      scrollRef.current.scrollBy({
        left: direction === "left" ? -amount : amount,
        behavior: "smooth",
      });
    }
  };

  return (
    <section className="relative w-full bg-background-100 py-16 md:py-20">
      <div className="w-full px-4 md:px-6">
        <div className="flex items-end justify-between mb-8 md:mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              Explore 14 Curated{" "}
              <span className="text-accent-500">Categories</span>
            </h2>
            <p className="mt-2 text-sm text-foreground-500">
              Browse every Pandabuy Spreadsheet category in one place
            </p>
          </div>
          <span className="hidden md:inline-block px-3 py-1.5 text-xs font-semibold whitespace-nowrap rounded-full bg-foreground-900 text-background-50">
            Daily Updated
          </span>
        </div>
      </div>

      <div className="relative">
        <button
          onClick={() => scroll("left")}
          className="absolute left-2 md:left-4 top-1/2 -translate-y-1/2 z-10 w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-background-50/90 text-foreground-700 hover:text-foreground-950 hover:bg-background-50 transition-all duration-200 cursor-pointer"
          aria-label="Scroll left"
        >
          <i className="ri-arrow-left-s-line text-lg"></i>
        </button>

        <div
          ref={scrollRef}
          className="flex gap-4 md:gap-5 overflow-x-auto px-4 md:px-6 pb-4"
          style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
        >
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="flex-shrink-0 w-[220px] md:w-[260px] group cursor-pointer"
            >
              <div className="rounded-lg overflow-hidden bg-background-50 aspect-[4/5] relative">
                <img
                  src={cat.imageUrl}
                  alt={"Pandabuy Spreadsheet " + cat.name}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="mt-3 px-1">
                <p className="text-sm font-semibold text-foreground-900">{cat.name}</p>
                <p className="text-xs text-foreground-500 mt-0.5">{cat.description}</p>
              </div>
              <span className="inline-block mt-2 text-xs font-bold text-primary-600 group-hover:text-primary-700">
                View →
              </span>
            </a>
          ))}
        </div>

        <button
          onClick={() => scroll("right")}
          className="absolute right-2 md:right-4 top-1/2 -translate-y-1/2 z-10 w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-background-50/90 text-foreground-700 hover:text-foreground-950 hover:bg-background-50 transition-all duration-200 cursor-pointer"
          aria-label="Scroll right"
        >
          <i className="ri-arrow-right-s-line text-lg"></i>
        </button>
      </div>
    </section>
  );
}